/* Emițătorul de clicuri pe MENIUL de navigație (bara de categorii desktop + sertarul mobil).
 *
 * SURSA UNICĂ e acest fișier. Se copiază identic ca `assets/am-nav-tracking.js` în tema
 * DEV și se include din `theme.liquid`, lângă `am-list-tracking.js`.
 *
 * DE CE (06.10.2026): „cine intră în meniul Luxury și cumpără ceva?" avea doar un proxy
 * — afișările colecțiilor `luxury-*` — fără să știm dacă vizitatorul venise din meniu.
 * Publică UN eveniment prin `Shopify.analytics.publish`:
 *   meniu_click — {cale: "Luxury > Boxe Luxury > Boxe active", url: "/collections/…",
 *                  nivel: 1-3, suprafata: "desktop" | "mobil"}
 * Pixelul (`ascultator-pixel.js`) îl trimite în GA4 ca `am_menu_click`, prin proxy.
 *
 * Se numără DOAR clicurile care navighează. Clicurile pe care tema le folosește ca să
 * deschidă un panou au `defaultPrevented` și se ignoră:
 *   - desktop: categoria de nivel 1 (`[data-am-menu-trigger]`) doar fixează panoul
 *     (`sections/header.liquid`, handlerul `trigger.addEventListener('click', …)`);
 *   - mobil: rândurile CU copii doar deschid acordeonul (`am-nav-drawer.js`).
 * De aceea ascultăm pe `window`, în faza de bubble: rulează după toate handlerele de pe
 * `document`, indiferent de ordinea în care s-au încărcat scripturile.
 *
 * LIVRAREA E BEST-EFFORT (Codex, 06.10.2026): pagina navighează imediat după clic, iar
 * pixelul face citiri asincrone (cookie-uri) înainte de `fetch(keepalive)`. Un procent de
 * clicuri se poate pierde — același drum și aceeași limită ca `reco_click`/`lista_click`.
 * Nu întârziem navigarea clientului pentru măsurare.
 *
 * Etichetele sunt cele RANDATE: pe .bg vin în bulgară. Calea se analizează pe piață
 * (hostname-ul din `page_location`); `url` e același pe ambele piețe.
 */
(function () {
  'use strict';

  if (window.__amNavTracking) return;   // inclus de două ori = evenimente dublate
  window.__amNavTracking = true;

  /* Aceeași regulă ca în proxy (`ga4-mp-proxy.ts`, schema `am_menu_click`): ce nu e
   * literă, cifră sau punctuație obișnuită devine spațiu, ca proxy-ul să nu respingă
   * tot evenimentul pentru un „–" sau „:" dintr-o etichetă. */
  var NEPERMIS = /[^\p{L}\p{N} &\/.,'’"()+!-]/gu;  // `"` = inch-ul diagonalelor TV (`85"+`)
  var MAX_SEGMENT = 50;

  function eticheta(t) {
    t = String(t || '');
    if (t.normalize) t = t.normalize('NFC');
    return t.replace(NEPERMIS, ' ').replace(/\s+/g, ' ').trim().slice(0, MAX_SEGMENT).trim();
  }

  /* Textul unui link; cardurile-imagine (showroom cinema) n-au text — cădem pe
   * `aria-label`, pe `alt`-ul imaginii, apoi pe ultimul segment al URL-ului. */
  function textLink(a) {
    var t = eticheta(a.textContent);
    if (t) return t;
    var img = a.querySelector && a.querySelector('img[alt]');
    t = eticheta(a.getAttribute('aria-label') || (img && img.getAttribute('alt')));
    if (t) return t;
    return eticheta((a.pathname || '').split('/').filter(Boolean).pop());
  }

  function textDin(el) { return el ? textLink(el) : ''; }

  /* Bara de categorii (desktop). Structura măsurată pe 06.10.2026, toate cele 248 de
   * linkuri: `.am-cat-item > a` (nivel 1: trigger sau „Promoții"), coloane cu titlu
   * (`a.am-cat-panel-column-title`) și listă, plus panouri fără coloane (liste simple,
   * carduri de showroom) — acolo linkul e direct nivel 2. */
  function caleDesktop(a) {
    var item = a.closest('.am-cat-item');
    if (!item) return null;
    var l1 = item.querySelector(':scope > a');
    var cale = [textDin(l1)];
    if (a !== l1) {
      var col = a.closest('.am-cat-panel-column');
      var titlu = col && col.querySelector(':scope > .am-cat-panel-column-title');
      if (titlu && titlu !== a) cale.push(textDin(titlu));
      cale.push(textLink(a));
    }
    return cale;
  }

  /* Sertarul mobil (`#nav`): acordeon `li.am-acc-l1/l2/l3`, eticheta fiecărui nivel e
   * `.am-nav-label` din rândul propriu. */
  function caleMobil(a) {
    var cale = [];
    var li = a.closest('.am-acc-l1, .am-acc-l2, .am-acc-l3');
    if (!li) return null;
    while (li) {
      var lbl = li.querySelector(':scope > .am-acc-row .am-nav-label, :scope > a .am-nav-label, :scope > a');
      cale.unshift(textDin(lbl));
      li = li.parentElement && li.parentElement.closest('.am-acc-l1, .am-acc-l2, .am-acc-l3');
    }
    return cale;
  }

  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || !e.target || !e.target.closest) return;
    var a = e.target.closest('a[href]');
    if (!a) return;

    var suprafata, cale;
    if (a.closest('.am-cat-bar')) { suprafata = 'desktop'; cale = caleDesktop(a); }
    else if (a.closest('#nav')) { suprafata = 'mobil'; cale = caleMobil(a); }
    else return;
    if (!cale || !cale.length || cale.length > 3 || cale.some(function (s) { return !s; })) return;

    var d = { cale: cale.join(' > '), nivel: cale.length, suprafata: suprafata };
    // Doar calea, fără query și doar pe același host: filtrele din URL ar umfla
    // cardinalitatea, iar un link extern n-are ce căuta în rapoartele de colecții.
    if (a.host === location.host && /^\/[a-z0-9\-\/_.]{0,120}$/.test(a.pathname)) d.url = a.pathname;

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('audio_monkey:meniu_click', d);
      }
    } catch (err) { /* măsurarea nu are voie să strice navigarea */ }
  });
})();
